// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-logo-wrapper,\n.emd-logo-link__image {\n  max-height: 100px;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
